import axios from 'axios'

const axiosInstance = axios.create()

// Optional: Uncomment to use these interceptors
// axiosInstance.interceptors.request.use(
//     (request) => {
//         console.log('Request URL:', request.url);
//         console.log('Request Headers:', JSON.stringify(request.headers, null, 2));
//         return request;
//     },
//     (error) => {
//         console.error('Request Error:', error);
//         return Promise.reject(error);
//     }
// );

// axiosInstance.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         console.error('Response Error:', (error.response && error.response.data) || 'Something went wrong');
//         return Promise.reject(error);
//     }
// );

export default axiosInstance
